@if (show$ | async) {
  <div class="my-assortment-menu form-check form-check-inv">
    @if (myAssortmentLabelSuffix$|async; as myAssortmentLabelSuffix) {
      <label for="myAssortmentCheckbox">
        <input id="myAssortmentCheckbox" type="checkbox" [checked]="selected" (click)="toggleSelection()"/>
        <i
          class="aimo-icon icon-inline icon-sm icon-white icon-house-line-bold mr-2 d-none"
          placement="bottom"
          container="body"
          triggers="mouseenter:mouseleave"
          [ngbPopover]="('aimo.product.myAssortmentHeader'+myAssortmentLabelSuffix.suffix) | cxTranslate"
        popoverClass="popover-md"></i>
        <i class="aimo-icon icon-inline icon-petrol-blue icon-house-line mr-2 d-lg-none d-inline-block"></i>
        <span
          placement="bottom"
          container="body"
          triggers="mouseenter:mouseleave"
          [ngbPopover]="('aimo.product.myAssortmentHeader'+myAssortmentLabelSuffix.suffix) | cxTranslate"
          popoverClass="popover-md"
          >{{ ('aimo.user.myAssortment' + myAssortmentLabelSuffix.suffix)  | cxTranslate }}</span
          >
        </label>
      }
    </div>
  }
